var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgArrowBottom = function SvgArrowBottom(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 21"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M4.41 7.736c.3-.3.773-.324 1.1-.07l.079.07 4.41 4.41 4.411-4.41c.3-.3.773-.324 1.1-.07l.079.07c.3.3.323.773.069 1.1l-.07.078-5 5c-.3.3-.772.324-1.1.07l-.078-.07-5-5a.833.833 0 0 1 0-1.178",
    clipRule: "evenodd"
  })));
};
export default SvgArrowBottom;